const SEO = [
	{
		page: "home",
		description:
			"Elimimian Osemaoje — Software Developer specialising in React, Flutter, Laravel and Web3. Building scalable, high-quality web and mobile applications from Lagos, Nigeria.",
		keywords: ["Elimimian Osemaoje", "Software Developer", "React Developer", "Flutter Developer", "Lagos Nigeria"],
	},
	{
		page: "about",
		description:
			"Learn about Elimimian Osemaoje's experience across software development, telecoms infrastructure, renewable energy, and education.",
		keywords: ["Elimimian Osemaoje", "Software Developer", "Work Experience", "Alpha Morgan Bank", "Huawei"],
	},
	{
		page: "articles",
		description:
			"Long-form thoughts by Elimimian Osemaoje on programming, leadership, product design, and technology.",
		keywords: ["Elimimian Osemaoje", "Tech Articles", "Programming Blog"],
	},
	{
		page: "projects",
		description:
			"Portfolio projects by Elimimian Osemaoje — from e-learning mobile apps to Web3 wallets and banking software.",
		keywords: ["Elimimian Osemaoje", "Portfolio", "Projects", "Flutter Apps", "React Apps"],
	},
	{
		page: "contact",
		description:
			"Get in touch with Elimimian Osemaoje — open to collaborations, freelance work, and new opportunities.",
		keywords: ["Elimimian Osemaoje", "Contact", "Hire Developer", "Lagos Nigeria"],
	},
	{
		page: "certifications",
		description:
			"Professional certifications earned by Elimimian Osemaoje across software, networking, and technology.",
		keywords: ["Elimimian Osemaoje", "Certifications", "CCNA", "Professional Credentials"],
	},
];

export default SEO;